import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {CircularProgress} from '@material-ui/core';
import {Pagination} from '@material-ui/lab';

import instance from '../../instance';
import $config from '../../config';
import {useNavigate} from 'react-router-dom';
import CallNotification from '../../context/NotificationContext';
import UserTitle from '../../context/UserTitle';
import './home-page.css';
import {useMediaQuery, useTheme, Box, Grid, Paper, Typography} from '@mui/material';
import StatusIcon from '../../ui/StatusIcon';
import {IKkm} from '../../interfaces/payment/IKkm';
import {getTextColorByPaymentInfo} from '../../functionts/getTextColorByPaymentInfo';

const useStyles = makeStyles({
    arrows: {
        display: 'flex',
        justifyContent: 'right',
        marginRight: '20px',
        marginTop: '10px',
    },
});

interface IUserIdProps {
    setCurrentPageClass: React.Dispatch<React.SetStateAction<string>>;
    isAdmin: boolean;
    userId: number | null;
    activeKKM: number | null;
    setActiveKKM: React.Dispatch<React.SetStateAction<number | null>>;
    setActiveNavElem: React.Dispatch<React.SetStateAction<string>>;
}

const HomePage = (props: IUserIdProps): React.JSX.Element => {
    const {setCurrentPageClass, isAdmin, userId, activeKKM, setActiveKKM, setActiveNavElem} = props;
    const [activeKKMEffect, setActiveKKMEffect] = useState<number | null>(null);
    const {handleErrorNotification} = CallNotification();
    const styles = useStyles();
    const navigate = useNavigate();

    const [currentDesk, setDesk] = useState<IKkm | null>(null);
    const [KKM, setKKM] = useState<IKkm[]>([]);
    const [isLoading, setLoading] = useState<boolean>(true);
    const [isEmpty, setEmpty] = useState<boolean>(true);

    const [totalPage, setTotalPage] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(0);

    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.down('md'));
    const [rowPerPage] = useState<number>(isMd ? 6 : window.innerHeight > 1700 ? 40 : 12);

    const submitClick = (e: React.MouseEvent) => {
        e.preventDefault();
        let currentNumber = Number(e.currentTarget.id);
        const currentElement = KKM && KKM[currentNumber];
        if (activeKKMEffect !== currentNumber) {
            setDesk(currentElement);
            setActiveKKMEffect(currentNumber);
            setActiveKKM(Number(currentElement?.kkm_id)); // here
            sessionStorage.setItem('activeKKM', JSON.stringify(currentElement?.kkm_id));
        } else {
            sessionStorage.setItem('activeKKM', JSON.stringify(null));
            setDesk(null);
            setActiveKKMEffect(null);
            setActiveKKM(null);
        }
    };

    const onSubmitGetKKMRequest = async (currentPage: number = 0) => {
        setLoading(true);
        if (isAdmin) {
            setLoading(false);
            return;
        }
        if (!isAdmin && !userId) {
            setLoading(false);
            return;
        }

        if ($config.debugMode & $config.D_INF) {
            console.log('checker:', Number(userId));
        }
        const request: any = {
            method: 'GetKKM',
            params: {
                user_id: Number(userId),
                limit: {
                    row_count: rowPerPage,
                    offset: rowPerPage * currentPage,
                },
            },
        };
        try {
            const response = await instance.post('/LK', request);
            handleErrorNotification(response);
            const responseData: IKkm[] = [...response.data.service];
            if (responseData.length < 1) {
                setKKM([]);
                setEmpty(true);
                setTotalPage(0);
                setLoading(false);
                return;
            }
            setKKM(responseData);
            const rawStored = sessionStorage.getItem('activeKKM');
            const storedId = rawStored && rawStored !== 'null' ? Number(JSON.parse(rawStored)) : null;

            if (storedId !== null && !Number.isNaN(storedId)) {
                const index = responseData.findIndex(item => Number(item.kkm_id) === storedId);
                if (index !== -1) {
                    setActiveKKMEffect(index);
                    setDesk(responseData[index]);
                    setActiveKKM(storedId);
                } else {
                    setActiveKKMEffect(null);
                    setDesk(null);
                    setActiveKKM(null);
                    sessionStorage.setItem('activeKKM', JSON.stringify(null));
                }
            } else if (activeKKM) {
                // если пропс activeKKM передан извне — попробовать применить его
                const index = responseData.findIndex(item => Number(item.kkm_id) === Number(activeKKM));
                if (index !== -1) {
                    setActiveKKMEffect(index);
                    setDesk(responseData[index]);
                } else {
                    setActiveKKMEffect(null);
                    setDesk(null);
                }
            }
            setEmpty(false);
            setTotalPage(Math.ceil(response.data.total / rowPerPage));
        } catch (error) {
            // console.log('Some Error with authorization request: ' + (error as Error).message);
        }
        setLoading(false);
    };

    const handlerGoToKKMOperation = (kkm_id: any) => {
        setActiveKKM(kkm_id ? Number(kkm_id) : null);
        setActiveNavElem('searchBill');
        navigate('/search-bill');
    };

    useEffect(() => {
        setCurrentPageClass('bg home');
    }, [setCurrentPageClass]);

    useEffect(() => {
        // noinspection JSIgnoredPromiseFromCall
        void onSubmitGetKKMRequest();
    }, [userId]);

    // Формирование блоков по условию.
    let emptyMsg;

    const ut = UserTitle({isAdmin: isAdmin});
    if (isAdmin) {
        if (ut) {
            emptyMsg = 'У пользователя нет доступных кассовых апаратов.';
        } else {
            emptyMsg = 'Нужно выбрать пользователя.';
        }
    } else {
        emptyMsg = 'У вас пока нет доступных кассовых апаратов.';
    }

    const OnChangePage = (event: any, value: any) => {
        setCurrentPage(value - 1);
        // noinspection JSIgnoredPromiseFromCall
        void onSubmitGetKKMRequest(value - 1);
    };
    return (
        <>
            {isLoading ? (
                <Box display="flex" justifyContent="center" alignItems="center" sx={{height: '60vh'}}>
                    <CircularProgress />
                </Box>
            ) : (
                <section className={'content'}>
                    <div className={'header'}>
                        <h1 className={'title'}>
                            Состояние касс
                            {ut}
                        </h1>
                    </div>
                    <div className={'workspace'}>
                        {isEmpty && (
                            <div className={'no-KKM'}>
                                <span className={'message'}>{emptyMsg}</span>
                            </div>
                        )}
                        {!isEmpty && (
                            <div className={'infoBlock'}>
                                <Box sx={{mb: 2}}>
                                    <Grid container spacing={2}>
                                        {KKM.map((desk, i) => {
                                            const paidUntil = desk?.create_payment_info?.paid_until_date ?? '';
                                            const balanceDisabled = !!desk?.create_payment_info?.balance_control_disabled;
                                            const rentAmount = Number(desk?.create_payment_info?.payment_amount_by_rent ?? 0);
                                            const upcomingAmount = Number(desk?.create_payment_info?.upcoming_payment_amount ?? 0);
                                            const balanceToShow =
                                                balanceDisabled || (rentAmount === 0 && !upcomingAmount) ? 0 : (desk?.balance_value ?? 0);
                                            const colorStatus = desk?.create_payment_info?.color_status ?? null;

                                            return (
                                                <Grid item xs={12} md={6} lg={4} key={desk.kkm_id}>
                                                    <Paper
                                                        id={String(i)}
                                                        onClick={submitClick}
                                                        elevation={3}
                                                        sx={{
                                                            p: 2,
                                                            cursor: 'pointer',
                                                            border: activeKKMEffect === i ? '1px solid' : '1px solid',
                                                            borderColor: activeKKMEffect === i ? 'primary.main' : 'divider',
                                                            backgroundColor: activeKKMEffect === i ? 'action.selected' : 'background.paper',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: 1,
                                                            minHeight: '164px',
                                                        }}
                                                    >
                                                        <Box display="flex" justifyContent="space-between" alignItems="start">
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <Box>
                                                                    <Typography variant="h6">{desk?.serial_number ?? '-'}</Typography>
                                                                    <Box display="flex" alignItems="center" gap={1}>
                                                                        <StatusIcon kkm={desk} showText />
                                                                    </Box>
                                                                </Box>
                                                            </Box>

                                                            <Box textAlign="right">
                                                                {paidUntil && (
                                                                    <Typography
                                                                        variant="caption"
                                                                        sx={{color: getTextColorByPaymentInfo(colorStatus)}}
                                                                    >
                                                                        {paidUntil === 'Не оплачено' ? paidUntil : 'Оплачено до: ' + paidUntil}
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                        </Box>

                                                        <Box>
                                                            <Typography variant="body2" color="textSecondary">
                                                                {desk?.department?.name ? desk.department.name : ''}
                                                                {desk?.department?.name && desk?.department?.address ? ' / ' : ''}
                                                                {desk?.department?.address ?? ''}
                                                            </Typography>
                                                            <Typography variant="body2" color="textSecondary">
                                                                С/н: {desk?.serial_number ?? '-'}
                                                            </Typography>
                                                            <Typography variant="body2" color="textSecondary">
                                                                Р/н: {desk?.reg_number ?? '-'}
                                                            </Typography>
                                                            <Typography variant="body2" color="textSecondary">
                                                                Модель: {desk?.model ?? ''}
                                                            </Typography>
                                                            <Typography variant="body2" color="textSecondary">
                                                                ОФД: {desk?.ofd?.name ?? '-'}
                                                            </Typography>

                                                            {/*<button onClick={handlerGoToKKMOperation} className={'button-primary'}>*/}
                                                            {/*    <span className={'btn-icon'} />*/}
                                                            {/*    Операции*/}
                                                            {/*</button>*/}

                                                            {/*<div>*/}
                                                            {/*    <p className={`${styles.schedulStatus} + ${currentDesk && currentDesk.status ? ' ' : styles.schedulStatusClose}`}>*/}
                                                            {/*        {currentDesk && currentDesk.status ? 'смена открыта' : 'смена закрыта'}*/}
                                                            {/*    </p>*/}
                                                            {/*    <span className={styles.infoAboutDesksValue}>*/}
                                                            {/*        {currentDesk && OFD && OFD[Number(currentDesk.ofd)]}*/}
                                                            {/*    </span>*/}
                                                            {/*</div>*/}
                                                        </Box>
                                                    </Paper>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </Box>

                                <div className={styles.arrows}>
                                    <Pagination
                                        className="pagination"
                                        variant={'outlined'}
                                        color={'primary'}
                                        count={totalPage || 1}
                                        page={currentPage + 1}
                                        onChange={OnChangePage}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </section>
            )}
        </>
    );
};

export default HomePage;
